import { Detail } from './_Index';

export class RisorsaLavorazione extends Detail {
    risorsaId: number;
    lavorazioneId: number;
}
